/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping custom
* Javascript here makes future theme updates easier.
*/

(function() {
  const selector = '[data-section-type="slideshow"] slider-component[data-play-once="true"]';

  function setupPlayOnce(slider) {
    if (slider.dataset.playOnceReady === 'true') return;

    let completed = false;

    function bindFlickity() {
      if (!slider.flkty || slider.dataset.playOnceReady === 'true') return false;

      slider.dataset.playOnceReady = 'true';

      function stopAtFinalSlide() {
        const finalIndex = slider.flkty.slides.length - 1;

        if (finalIndex >= 0 && slider.flkty.selectedIndex >= finalIndex) {
          completed = true;
        }

        if (completed) {
          slider.flkty.stopPlayer();
        }
      }

      slider.flkty.on('change', stopAtFinalSlide);
      slider.flkty.on('settle', stopAtFinalSlide);

      slider.addEventListener('theme:slider:deselect', function() {
        if (completed) {
          requestAnimationFrame(function() {
            if (slider.flkty) slider.flkty.stopPlayer();
          });
        }
      });

      stopAtFinalSlide();
      return true;
    }

    if (bindFlickity()) return;

    const section = slider.closest('[data-section-id]') || document;

    function onSliderLoaded() {
      if (bindFlickity()) {
        section.removeEventListener('theme:slider:loaded', onSliderLoaded);
      }
    }

    section.addEventListener('theme:slider:loaded', onSliderLoaded);
    requestAnimationFrame(bindFlickity);
  }

  function initialize(root) {
    if (root.matches && root.matches(selector)) setupPlayOnce(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(setupPlayOnce);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function(event) {
    initialize(event.target);
  });
})();
